<template>
  <div>
    <HeaderGestion/>
    <SubHeaderGestion nombreGestion="Sellos"/>
    <FormSellos/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormSellos from '../components/FormSellos.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormSellos },
  name: 'GesSellos'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
